module.exports = __webpack_public_path__ + "img/page.49e24ea6.png";